<template>
  <a-card :bordered="false">
    <div class="top-box" v-if="activeKey==4">
      <a-form>
        <search-header :col="4">
          <search-list>
            <a-form-item label="店铺名称" v-bind="searchItemLayout">
              <a-input v-model="queryParams.shop_name" placeholder="请输入"></a-input>
            </a-form-item>
            <a-form-item label="电话" v-bind="searchItemLayout">
              <a-input v-model="queryParams.mobile" placeholder="请输入"></a-input>
            </a-form-item>
            <a-form-item v-bind="searchItemLayout">
              <a-button style="margin: 0 20px" type="primary" @click="onSearchEvent">查询</a-button>
              <a-button
                type="primary"
                :disabled="!selectedRowKeys || !selectedRowKeys.length"
                @click="updateOrderSynchronization({},true)"
              > 批量设置
              </a-button>
            </a-form-item>
          </search-list>
        </search-header>
      </a-form>
    </div>
    <a-tabs v-model="activeKey" type="card" @change="tabActiveKey">
      <a-tab-pane :key="1" tab="运营商订单"></a-tab-pane>
      <a-tab-pane :key="2" tab="云仓订单"></a-tab-pane>
      <a-tab-pane :key="3" tab="直采订单"></a-tab-pane>
      <a-tab-pane :key="4" tab="分销订单"></a-tab-pane>
    </a-tabs>
    <a-table
      v-if="activeKey < 4"
      rowKey="index"
      :columns="getColumns()"
      :data-source="dataList">
      <span slot="action" slot-scope="text, record">
        <a @click="updateOrderSynchronization(record,false)">更改订单同步归属</a>
      </span>
    </a-table>
    <search-page-view
      v-else
      ref="pageList"
      rowKey="staffId"
      :columns="getColumns()"
      :col="4"
      :queryParams="queryParams"
      :requestPromise="getListPromise"
      :enableSearch="false"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <div slot="action" slot-scope="rowItem">
        <a @click="updateOrderSynchronization(rowItem.record,false)">更改订单同步归属</a>
      </div>
    </search-page-view>
    <a-modal
      :title="synchronizationTitle"
      :width="500"
      v-model="synchronizationVisible"
      @cancel="synchronizationVisible=false"
      @ok="handleOk"
    >
      <p style="padding-left: 12px">订单同步到ERP，订单归属ERP销售</p>
      <a-form-item label="账号职位编码" v-bind="{
          labelCol: { span: 6 },
          wrapperCol: { span: 17 }
        }">
        <a-input v-model="erp_account_code" placeholder="请输入" :maxLength="50"></a-input>
      </a-form-item>
    </a-modal>

  </a-card>
</template>

<script>
import searchForm from '../../../../utils/mixins/searchFormMixins'
import formMixin from '../../../../utils/mixins/formMixins'
import ErpDirectAssistantMixins from './ErpDirectAssistantMixins'

export default {
  name: 'OrderSynchronization',
  components: {},
  mixins: [searchForm, formMixin, ErpDirectAssistantMixins],
  data() {
    return {
      queryParams: {},
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      searchItemLayout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 }
      },
      activeKey: 1,
      selectedRowKeys: [],
      synchronizationVisible: false,
      synchronizationTitle: '',
      erp_account_code: '',
      staffId: '',
      dataList: [],
      isBatch: false
    }
  },
  created() {
    this.queryParams.merchantId = this.$store.getters.userInfo.merchantId
    this.queryParams.platformId = this.getPlatformConfig().platformId
  },
  mounted() {
    this.refsPageList()
  },
  methods: {
    onSearchEvent() {
      this.$refs.pageList.refresh(true)
    },
    tabActiveKey(e) {
      this.refsPageList()
    },
    refsPageList() {
      this.$nextTick(() => {
        this.queryParams = {}
        this.selectedRowKeys = []
        this.dataList = []
        if (this.activeKey == 4) {
          this.$refs.pageList.updateSelect([], [])
        } else {
          this.getDataList()
        }
      })
    },
    getDataList() {
      let params = {
        category: this.activeKey
      }
      this.getHttpServices().getUserService().post('/erpGroup/v2/getMerchantCategory', params)
        .then(res => {
          res.index = 1
          this.dataList = [res]
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    updateOrderSynchronization(record, type) {
      this.isBatch = type
      this.staffId = ''
      this.erp_account_code = ''
      this.erp_account_code = !type ? record.erpAccountCode : ''
      this.staffId = !type ? record.staffId : ''
      this.synchronizationTitle = !type ? '修改订单同步归属' : '批量设置'
      this.synchronizationVisible = true
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
    },
    handleOk() {
      let params = {}
      let url = ''
      if (this.activeKey == 4) {
        let staffIds = this.isBatch ? this.selectedRowKeys : [this.staffId]
        params = {
          staffIds: staffIds
        }
        url = '/erpGroup/v2/saveErpGroupOrderStaff'
      } else {
        url = '/erpGroup/v2/saveErpGroupOrderMerchant'
        params = {
          category: this.activeKey
        }
      }
      params.erp_account_code = this.erp_account_code
      this.getHttpServices().getUserService().post(url, params)
        .then(res => {
          this.$message.success(this.synchronizationTitle + '成功')
          this.synchronizationVisible = false
          if (this.activeKey == 4) {
            this.selectedRowKeys = []
            this.$refs.pageList.updateSelect([], [])
            this.$refs.pageList.refresh(true)
          } else {
            this.getDataList()
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getListPromise(params) {
      return this.getHttpServices().getUserService().post('/erpGroup/v2/getOrderStaffList', params)
    },
    getColumns() {
      let obj = {
        title: 'ID',
        dataIndex: 'staffId',
        width: '150px'
      }
      let list = [
        {
          title: '店铺名称',
          dataIndex: 'shopName',
          width: '30%'
        },
        {
          title: '姓名',
          dataIndex: 'name'
        },
        {
          title: '电话',
          dataIndex: 'mobile'
        },
        {
          title: '归属ERP帐号编号',
          dataIndex: 'erpAccountCode'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
      if (this.activeKey == 4) {
        list.unshift(obj)
      }
      return list
    }
  }
}
</script>
<style scoped lang="less">
</style>